import { SingleClassView } from "../components/singleClass/SingleClassView";

export const SingleClass = () => {
  return <SingleClassView />
};
